import React from 'react';

const EmptyWidget = (props) => {
  const html = props.html;

  return (
    <div className="empty-widget-container">
      {html && (
        <div
          dangerouslySetInnerHTML={{
            __html: html,
          }}
        />
      )}
    </div>
  );
};

export default EmptyWidget;
